import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  CHARGE_AFTER_STORE_ID_ECOMM,
  CHARGE_AFTER_INSIDE_SALES_STORE_ID,
  CHARGE_AFTER_CUSTOMER_CARE_STORE_ID,
  CHARGE_AFTER_IN_SALES_STORE_ID,
} from '../../utils/common/constants';

const ChargeAfterSdk = () => {
  const { isDraft, storeKey } = useSelector((state) => ({
    isDraft: state.cart?.isDraft ?? false,
    storeKey: state.cart?.store?.key,
  }));

  const isLoadingCart = useSelector(
    (state) =>
      state.cart?.status === 'loading' || state.cart?.status === 'idle',
  );

  useEffect(() => {
    const onLoadChargeAfterSDKScript = () => {
      const storeIdsToBeOverriddenWithInsales = [
        CHARGE_AFTER_INSIDE_SALES_STORE_ID,
        CHARGE_AFTER_CUSTOMER_CARE_STORE_ID,
      ];

      const draftOrderStoreId = storeIdsToBeOverriddenWithInsales.includes(
        storeKey,
      )
        ? CHARGE_AFTER_IN_SALES_STORE_ID
        : storeKey;

      const config = {
        apiKey: process.env.CHARGE_AFTER_PUBLIC_KEY,
        storeId:
          isDraft && storeKey ? draftOrderStoreId : CHARGE_AFTER_STORE_ID_ECOMM,
      };

      window.ChargeAfter.init(config);
    };

    const loadChargeAfterSdk = () => {
      const script = document.createElement('script');
      script.src = `${process.env.CHARGE_AFTER_SDK_URL}?t=${Date.now()}`;
      script.type = 'text/javascript';
      script.async = true;
      script.onload = onLoadChargeAfterSDKScript;
      document.getElementsByTagName('body')[0].appendChild(script);
    };

    if (
      (!window.ChargeAfter || !window.ChargeAfter?.config?.storeId) &&
      !isLoadingCart
    ) {
      loadChargeAfterSdk();
    }
  }, [isDraft, isLoadingCart, storeKey]);

  return null;
};

export default ChargeAfterSdk;
